import { useDispatch, useSelector } from 'react-redux'
import ListaPastasDocumentos from './ListaPastasDocumentos'
import css from './styles.module.css'
import { Button, Spinner } from 'react-bootstrap'
import { useState } from 'react'
import LoadingModal from '../../../components/loadingModal'
import ModalDocumentoMoverParaPasta from '../documento/ModalDocumentoMoverParaPasta'
import { ApiEndpoints, reqPatch, reqPostNew } from '../../../config/apiClient'
import { toast } from 'react-toastify'
import { getDocumentosReqPost, getPageUrlIdPasta } from './DocumentosFuncoes'
import { atualizar, iDocsSelecionados, loadingPasta } from '../documentosSlice'
import ModalDocumentoRenomear from '../documento/ModalDocumentoRenomear'
import ModalRenomearPasta from './ModalRenomearPasta'
import { getCookie } from '../../../config/cookies'

export default function NavegacaoDocumentos({ loadingPage }:iPropsNav) {
    const [loading, setLoading] = useState<boolean>(false)
    const [showModalPasta, setShowModalPasta] = useState<boolean>(false)
    const [showModalRenomearDocumento, setShowModalRenomearDocumento] = useState<boolean>(false)
    const [showModalRenomearPasta, setShowModalRenomearPasta] = useState<boolean>(false)
    const caminho = useSelector((state:any) => state.uiDocumentos.caminho)
    const documentos:any[] = useSelector((state:any) => state.uiDocumentos.documentos)
    const pastas:any[] = useSelector((state:any) => state.uiDocumentos.pastas)
    // const selecionados = useSelector((state:any) => state.uiDocumentos.selecionados)
    const dispatch = useDispatch()

    async function handlePastaMover(id_pasta: number) {
        setShowModalPasta(false)
        setLoading(true)
        const selecionados = getObjetosSelecionados()
        // console.log(`MOVER PARA PASTA ${id_pasta}`)
        // console.log(selecionados)

        if (selecionados.documentos.length === 0 && selecionados.pastas.length === 0) {
            toast.warning(`Selecione algum objeto!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setLoading(false)
            return
        }

        for (let id_pasta_aux of selecionados.pastas) {
            if (id_pasta_aux === id_pasta) {
                toast.warning(`Não é possível mover uma pasta para a mesma pasta!`, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
                setLoading(false)
                return
            }
        }
        const apiPastas = await moverPastas(selecionados.pastas, id_pasta)
        const apiDocs = await moverDocumentos(selecionados.documentos, id_pasta)
        if (apiPastas.status === 200 && apiDocs.status === 200) {
            toast.success(`Objetos movidos com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await atualizarStateDocumentos()
        }
        setLoading(false)
    }
    async function atualizarStateDocumentos() {
        const id_pasta_atual_navegacao = getPageUrlIdPasta()
        const api = await getDocumentosReqPost(id_pasta_atual_navegacao!)
        if (api.status === 200) {
            dispatch(atualizar(api.data))
        }
    }
    async function handleAtualizar() {
        setLoading(true)
        await atualizarStateDocumentos()
        setLoading(false)
    }

    function getObjetosSelecionados() {
        let selecionados:iDocsSelecionados = {
            documentos: [],
            pastas: []
        }
        for (let doc of documentos) {
            if (doc['selecionado'] === true) {
                selecionados.documentos.push(doc.codigo)
            }
        }
        for (let pasta of pastas) {
            if (pasta['selecionado'] === true) {
                selecionados.pastas.push(pasta.id_pasta)
            }
        }
        return selecionados
    }

    async function moverPastas(ids_pastas:any[], id_pasta:number) {
        if (ids_pastas.length === 0) {
            return {
                status: 200,
                data: {}
            }
        }
        const dados = {
            ids_pasta: ids_pastas,
            id_pasta_destino: id_pasta
        }
        const api = await reqPatch(ApiEndpoints.documentoMoverPastas, dados)
        return api
    }
    async function moverDocumentos(codigos:any[], id_pasta:number) {
        if (codigos.length === 0) {
            return {
                status: 200,
                data: {}
            }
        }
        const dados = {
            codigos: codigos,
            id_pasta: id_pasta
        }
        const api = await reqPatch(ApiEndpoints.documentoMoverPasta, dados)
        return api
    }

    async function handleRenomearDocumento(dados:any) {
        setShowModalRenomearDocumento(false)
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.documentoRenomear, dados)
        if (api.status === 200) {
            toast.success(`Nome editado com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        await atualizarStateDocumentos()
        setLoading(false)
    }

    async function handleRenomearPasta(dados:any) {
        setShowModalRenomearPasta(false)
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.documentoEditarPastas, dados)
        if (api.status === 200) {
            toast.success(`Nome editado com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }
        await atualizarStateDocumentos()
        setLoading(false)
    }

    async function handleDeletar() {
        setLoading(true)
        const selecionados = getObjetosSelecionados()
        if (selecionados.documentos.length > 0 && selecionados.pastas.length > 0) {
            toast.warning(`Selecione apenas 1 Objeto para excluir!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setLoading(false)
            return
        }

        if (selecionados.documentos.length > 1) {
            toast.warning(`Selecione apenas 1 Objeto para excluir!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setLoading(false)
            return
        } else if (selecionados.documentos.length === 1) {
            let codigo:any = selecionados.documentos[0]
            let documento:any = documentos.filter(reg => reg.codigo === codigo)[0]
            await deletarDocumentoSelecionado(documento)
            setLoading(false)
            return
        }

        if (selecionados.pastas.length > 1) {
            toast.warning(`Selecione apenas 1 Objeto para excluir!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            setLoading(false)
            return
        } else if (selecionados.pastas.length === 1) {
            let id_pasta:any = selecionados.pastas[0]
            let pasta:any = pastas.filter(reg => reg.id_pasta === id_pasta)[0]
            await deletarPastaSelecionada(pasta)
            setLoading(false)
            return
        }
        setLoading(false)
    }

    async function deletarDocumentoSelecionado(documento:any) {
        if (!window.confirm(`Tem certeza que deseja excluir o documento: ${documento.nome}?`)) {
            setLoading(false)
            return
        }
        const dados = {
            id_documento: documento.id,
            id_usuario: getCookie("id_user"),
        }
        const api = await reqPostNew(ApiEndpoints.documentoDeletar, dados)
        if (api.status === 200) {
            toast.success(`Documento deletado com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await atualizarStateDocumentos()
        }
    }

    async function deletarPastaSelecionada(pasta:any) {
        if (!window.confirm(`Tem certeza que deseja excluir a pasta: ${pasta.nome}?`)) {
            setLoading(false)
            return
        }
        let dados = {
            id_pasta: pasta.id_pasta,
            id_pasta_pai: pasta.id_pasta_pai,
            nome: pasta.nome,
            lixeira: pasta.lixeira,
        }
        const api = await reqPostNew(ApiEndpoints.documentoDeletarPastas, dados)
        if (api.status === 200) {
            toast.success(`Pasta deletada com sucesso!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await atualizarStateDocumentos()
        }
    }

    async function handleRenomear() {
        const selecionados = getObjetosSelecionados()
        if (selecionados.documentos.length > 0 && selecionados.pastas.length > 0) {
            toast.warning(`Não é possível renomear documentos e pastas ao mesmo tempo!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }
        if (selecionados.documentos.length > 0) {
            setShowModalRenomearDocumento(true)
            return
        }
        if (selecionados.pastas.length > 0) {
            setShowModalRenomearPasta(true)
            return
        }
    }

    return (
        <div id="div_navdocs">
            <LoadingModal handleClose={() => {}} show={loading} />

            { showModalPasta && <ModalDocumentoMoverParaPasta show={showModalPasta} handleClose={() => {
                setShowModalPasta(false)
            }} handlePasta={handlePastaMover} /> }

            {
                documentos.filter(reg => reg.selecionado === true).length > 0 &&
                <ModalDocumentoRenomear show={showModalRenomearDocumento} documento={documentos.filter(reg => reg.selecionado === true)[0]} handleClose={() => {
                    setShowModalRenomearDocumento(false)
                }} handleRenomear={handleRenomearDocumento} />
            }

            {
                pastas.filter(reg => reg.selecionado === true).length > 0 &&
                <ModalRenomearPasta show={showModalRenomearPasta} pasta={pastas.filter(reg => reg.selecionado === true)[0]} handleClose={() => {
                    setShowModalRenomearPasta(false)
                }} handleRenomear={handleRenomearPasta} />
            }

            <div id={css.div_controls}>
                {/* <p className={css.current_path}>Home</p> */}
                <MostrarCaminhoAtual pastas={caminho} />
                <div>
                    <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { handleAtualizar() }} style={{ display: "inline-flex", alignItems: "center", borderRadius: "20px", justifyContent: "center", padding: "0px", width: "38px", height: "38px" }} >
                        <span className="material-symbols-outlined" style={{ padding: "0px", margin: "0px" }}>
                            refresh
                        </span>
                    </Button>
                    <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { handleRenomear() }} >Renomear</Button>
                    <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { handleDeletar() }} >Excluir</Button>
                    <Button className={css.btn_acoes} variant="outline-secondary" onClick={() => { setShowModalPasta(true) }} >Mover</Button>
                </div>
            </div>
            { loadingPage && <Spinner /> }
            { !loadingPage && <ListaPastasDocumentos /> }

            <br></br>
            <br></br>
            <br></br>
            <a href={`${ApiEndpoints.apiOld}/dashboard/documentos`}>Página antiga</a>
        </div>
    )
}
interface iPropsNav {
    loadingPage: boolean
}

export function MostrarCaminhoAtual({ pastas }:iPropsCaminho) {
    const dispatch = useDispatch()

    async function handleClick(mouseClick: number, id_pasta: number) {
        const link = `/documentos/todos?pasta=${id_pasta}`
        if (mouseClick === 1) {
            window.open(link)
            return
        }
        if (mouseClick === 0) {
            const id_pasta_atual = getPageUrlIdPasta()
            if (id_pasta_atual === null) {
                window.location.href = link
                return
            }
            if (id_pasta_atual !== id_pasta) {
                window.history.pushState("OB PORTUS .NET", "OB PORTUS DOCUMENTOS", `/documentos/todos?pasta=${id_pasta}`)
                dispatch(loadingPasta({status: true}))
                const api = await getDocumentosReqPost(id_pasta)
                dispatch(loadingPasta({status: false}))
                if (api.status === 200) {
                    dispatch(atualizar(api.data))
                }
                return
            }
        }
    }

    if (pastas.length === 0) {
        return (
            <div className='div-row'>
                <p onClick={(event) => { handleClick(event.button, 0) }} onAuxClick={(event) => { handleClick(event.button, 0) }} className={css.link_caminho}>Pasta Inicial</p>
            </div>
        )
    }

    if (pastas.length === 1) {
        let id_pasta = 0
        let pasta = pastas[0]
        if (pasta.id_pasta !== null) {
            id_pasta = pasta.id_pasta
        }
        return (
            <div className={css.div_caminhos}>
                <p onClick={(event) => { handleClick(event.button, id_pasta) }} onAuxClick={(event) => { handleClick(event.button, id_pasta) }} style={{marginRight: "10px"}} className={css.link_caminho}>{pasta.nome}</p>
            </div>
        )
    }

    return (
        <div className='div-row'>
            {
                pastas.map((pasta, idx, array) => {
                    let id_pasta = 0
                    if (pasta.id_pasta !== null) {
                        id_pasta = pasta.id_pasta
                    }
                    return (
                        <div key={idx} className={css.div_caminhos}>
                            <p onClick={(event) => { handleClick(event.button, id_pasta) }} onAuxClick={(event) => { handleClick(event.button, id_pasta) }} className={css.link_caminho}>{pasta.nome}</p>
                            <span className="material-symbols-outlined icon_caminho" style={{fontSize: "16px", fontWeight: "bold", margin: "0px 5px"}}>
                            arrow_forward_ios
                            </span>
                        </div>
                    )
                })
            }
        </div>
    )
}
interface iPropsCaminho {
    pastas: any[]
}
